export default __webpack_public_path__ + "static/media/corner.d92549f0.svg";